"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _search = _interopRequireDefault(require("./components/search"));

var _number = _interopRequireDefault(require("./components/number"));

var _export = _interopRequireDefault(require("./components/export"));

var _exportSelector = _interopRequireDefault(require("./components/export-selector"));

var _columnSelector = _interopRequireDefault(require("./components/column-selector"));

var _rightViewSelector = _interopRequireDefault(require("./components/right-view-selector"));

var _multiSelect = _interopRequireDefault(require("./components/multi-select"));

var _filterSelector = _interopRequireDefault(require("./components/filter-selector/"));

var _filterSelectorBar = _interopRequireDefault(require("./components/filter-selector-bar"));

var _rearrange = _interopRequireDefault(require("./components/rearrange"));

var _comboBox = _interopRequireWildcard(require("./components/combo-box"));

var _implementation = _interopRequireDefault(require("./components/tabs/implementation"));

var _viewSwitch = _interopRequireDefault(require("./components/view-switch"));

var _mobileDetectionHelper = _interopRequireDefault(require("@eig-builder/core-utils/helpers/mobile-detection-helper"));

var _useResponsiveQuery = require("@eig-builder/core-utils/hooks/useResponsiveQuery");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  height: 64px;\n  padding: ", ";\n  display: flex;\n  align-items: flex-start;\n  vertical-align: middle;\n  justify-content: space-between;\n\n  background: ", ";\n  border-bottom: 1px solid ", ";\n  border-top-right-radius: ", "px;\n  border-top-left-radius: ", "px;\n  position: relative;\n  box-shadow: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Navbar = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.theme.spacing(3, 6, 3, 0);
}, function (props) {
  return props.theme.palette.white.main;
}, function (props) {
  return props.theme.palette.black.lighter;
}, function (props) {
  return props.mobile ? 0 : props.theme.shape.borderRadius;
}, function (props) {
  return props.mobile ? 0 : props.theme.shape.borderRadius;
}, function (props) {
  return "0 0 0 1px ".concat(props.theme.palette.black.lightest, ", 0 2px 4px 0 ").concat(props.theme.palette.black.lightest, ", 0 2px 1px 0 ").concat(props.theme.palette.black.lighter, ";");
});

var DataGridNavbar = function DataGridNavbar(_ref) {
  var children = _ref.children;
  var isMoblie = (0, _useResponsiveQuery.useIsMobile)();
  return /*#__PURE__*/_react["default"].createElement(Navbar, {
    mobile: isMoblie
  }, children);
};

var Filtering = function Filtering(_ref2) {
  var useTabs = _ref2.useTabs,
      implementationProps = (0, _objectWithoutProperties2["default"])(_ref2, ["useTabs"]);
  return useTabs && !(0, _mobileDetectionHelper["default"])() ? /*#__PURE__*/_react["default"].createElement(_implementation["default"], implementationProps) : /*#__PURE__*/_react["default"].createElement(_comboBox.ComboBoxImplementation, implementationProps);
};

Filtering.propTypes = {
  useTabs: _propTypes["default"].bool
};
Filtering.defaultProps = {
  useTabs: false
};
DataGridNavbar.Search = _search["default"];
DataGridNavbar.ViewSwitch = _viewSwitch["default"];
DataGridNavbar.ComboBox = _comboBox["default"];
DataGridNavbar.Filtering = Filtering;
DataGridNavbar.Number = _number["default"];
DataGridNavbar.Export = _export["default"];
DataGridNavbar.RightViewSelector = _rightViewSelector["default"];
DataGridNavbar.ColumnSelector = _columnSelector["default"];
DataGridNavbar.MultiSelect = _multiSelect["default"];
DataGridNavbar.FilterSelector = _filterSelector["default"];
DataGridNavbar.FilterSelectorBar = _filterSelectorBar["default"];
DataGridNavbar.Rearrange = _rearrange["default"];
DataGridNavbar.ExportSelector = _exportSelector["default"];
DataGridNavbar.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node])
};
var _default = DataGridNavbar;
exports["default"] = _default;